export const COOKIE_NAME = {
  LANGUAGE: 'language',
}

export enum COOKIE_CATEGORIES {
  Essential = 1,
  Performance = 2,
  Functional = 3,
  Marketing = 4,
}
